import React, { useState } from 'react';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import CompactDropdownStyled from './CompactDropdown.styled';

export interface CompactDropdownOptionProps {
  key: string;
  value: string;
}

export interface CompactDropdownProps {
  className?: string;
  id: string;
  label: string;
  options?: CompactDropdownOptionProps[];
  defaultValue: string;
  action?: (e?: any) => void;
  selected?: string;
}

const CompactDropdown = ({
  className,
  id,
  label,
  options,
  selected,
  defaultValue,
  action,
}: CompactDropdownProps) => {
  if (!options || options?.length < 1) return null;
  return (
    <CompactDropdownStyled className={className}>
      <label className="compact-dropdown__label sr-only" htmlFor={id}>
        {label}
      </label>
      <div className="compact-dropdown__select--wrapper">
        <Icon
          className="compact-dropdown__triangle"
          icon={IconsDictionary.Triangle}
          height={24}
          width={24}
        />
        <select
          name={label}
          id={id}
          onChange={e => {
            if (action) action(e);
          }}
          value={selected || defaultValue}
          className="compact-dropdown__select"
        >
          <option value="">All branches</option>
          {options?.map((option: CompactDropdownOptionProps) => {
            const { key, value } = option;
            return (
              <option key={key} value={value}>
                {value}
              </option>
            );
          })}
        </select>
      </div>
    </CompactDropdownStyled>
  );
};

export default CompactDropdown;
